<mat-sidenav-container  style="display: flex;flex-direction: column;justify-content: center;align-items: center;text-align: center;min-height: 100vh;">
  <router-outlet></router-outlet>
</mat-sidenav-container>






